var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 20,
    viewBox: "0 0 36 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 1.24682C36 0.930527 35.8792 0.606842 35.6446 0.364105C35.1754 -0.121367 34.4077 -0.121367 33.9386 0.364105L17.8809 16.9805L2.05786 0.606839C1.58871 0.121365 0.821012 0.121365 0.351866 0.606839C-0.117281 1.09231 -0.117281 1.88672 0.351865 2.37219L17.0279 19.6359C17.4971 20.1214 18.2648 20.1214 18.7339 19.6359L35.6446 2.13682C35.8863 1.88673 36 1.57047 36 1.24682Z",
    fill: "#3EE812"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.41948a9a5d1735a38b05f646b60f8de9.svg";
export { ForwardRef as ReactComponent };